const projects = [
  {
    year: 2024,
    project: "Aptos Retail",
    madeAt: "Nebo",
    builtWith: ["Ruby on Rails", "Python", "Algolia", "GSAP", "MS SQL"],
    link: "https://www.aptos.com/",
  },
  {
    year: 2024,
    project: "Revionics",
    madeAt: "Nebo",
    builtWith: ["Ruby on Rails", "Python", "Algolia", "GSAP"],
    link: "https://revionics.com/",
  },
  {
    year: 2024,
    project: "Nebo Website",
    madeAt: "Nebo",
    builtWith: ["Ruby on Rails", "GSAP", "jQuery"],
    link: "https://www.neboagency.com/",
  },
  {
    year: 2024,
    project: "AMY Awards",
    madeAt: "Nebo",
    builtWith: ["Ruby on Rails", "GSAP", "jQuery"],
    link: "https://www.amyawardsatl.com/",
  },
  {
    year: 2024,
    project: "BeKind365",
    madeAt: "Nebo",
    builtWith: ["Wordpress", "Three.js", "Ms SQL"],
    link: "https://bekind365.world/",
  },
  {
    year: 2023,
    project: "Foundation Technologies",
    madeAt: "Nebo",
    builtWith: ["PHP", "jQuery", "Ms SQL"],
    link: "https://www.foundationtechnologies.com/",
  },
  {
    year: 2023,
    project: "MMM Law",
    madeAt: "Nebo",
    builtWith: ["Ruby on Rails", "jQuery", "GSAP"],
    link: "https://www.mmmlaw.com/",
  },
  {
    year: 2023,
    project: "Georgia Tech Scheller College of Business",
    madeAt: "Nebo",
    builtWith: ["Cascade CMS", "SASS", "GSAP", "Adobe XD"],
    link: "https://www.scheller.gatech.edu/",
  },
  {
    project: "The Atlanta University Center",
    madeAt: "Nebo",
    builtWith: ["Wordpress", "PHP", "SASS", "Figma"],
    link: "https://aucartcollective.org/",
  },
  {
    year: 2023,
    project: "Golf House Academy",
    madeAt: "Nebo",
    builtWith: ["Ruby on Rails", "GSAP", "jQuery"],
    link: "https://golfhouseacademy.com/",
  },
  {
    project: "Pet PLAY",
    madeAt: "Nebo",
    builtWith: ["Shopify", "Node.js", "AWS", "LiquidJS"],
    link: "https://www.petplay.com/",
  },
  {
    year: 2022,
    project: "Contec",
    madeAt: "Nebo",
    builtWith: ["Hubspot", "jQuery", "Preact", "GSAP"],
    link: "https://www.contecinc.com/",
  },
  {
    project: "Payroc",
    madeAt: "Nebo",
    builtWith: ["Wordpress", "HubSpot", "MySQL", "PHP"],
    link: "https://payroc.com/",
  },
  {
    year: 2022,
    project: "Starlight",
    madeAt: "Nebo",
    builtWith: ["Ruby on Rails", "GSAP", "jQuery", "AWS"],
    link: "https://www.starlighthomes.com/",
  },
  {
    project: "LandYield",
    madeAt: "Nebo",
    builtWith: ["Wordpress", "PHP", "GSAP", "Ms SQL"],
    link: "https://landyield.com/",
  },
  {
    year: 2022,
    project: "TPL",
    madeAt: "Nebo",
    builtWith: ["Wordpress", "PHP", "jQuery", "GSAP", "Ms SQL"],
    link: "https://www.tpl.org/",
  },
  {
    year: 2021,
    project: "Eleanor Auto",
    madeAt: "",
    builtWith: ["React", "GSAP", "styled-components", "Figma"],
    link: "https://eleanor-reform-test-zaidkhan.vercel.app/",
  },
  {
    year: 2021,
    project: "Suspect Gifs",
    madeAt: "",
    builtWith: ["React", "giphy API", "CSS"],
    link: "https://zaidkhan144.github.io/memory-game/",
  },
  {
    year: 2021,
    project: "Utah Jazz",
    madeAt: "",
    builtWith: ["React", "SASS", "Adobe XD"],
    link: "https://zaidkhan144.github.io/utah-jazz-project/",
  },
  {
    year: 2021,
    project: "Portfolio Project V1",
    madeAt: "",
    builtWith: ["JavaScript ES6", "jQuery", "Webpack"],
    link: "https://personal-web-v1.netlify.app/",
  },
  {
    year: 2021,
    project: "Milna",
    madeAt: "",
    builtWith: ["React", "Redux", "styled-components", "Axios"],
    link: "https://github.com/ZaidKhan144/milna-frontend",
  },
  {
    year: 2021,
    project: "Uptown Skate Shop",
    madeAt: "",
    builtWith: ["React", "styled-components", "Framer Motion"],
    link: "https://zaidkhan144.github.io/shopping-cart/#/",
  },
];

export default projects;
